import { authenticatedAxios } from '../../utils/axios'
import CONSTANTS from '../../utils/constants'
import ENDPOINTS from '../constant'
import { updateCssVariables } from '../../utils/utils'
import { defaultTheme, youthTheme } from '../../assets/themes'

const isFixedLineCustomer = () => {
  const storedCustomerType = localStorage.getItem('customerType')
  if (!storedCustomerType) {
    return false
  }
  try {
    const parsedType = JSON.parse(storedCustomerType)
    return parsedType === 1 || parsedType === 2
  } catch (error) {
    return false
  }
}

export const getCustomerInfoApi = async () => {
  let responseData = { data: {}, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.GetCustomerInfoLite}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
      let name = localStorage.setItem(
        'name',
        JSON.stringify(res.data.result.name)
      )
      if (name !== '' && name !== null) {
        localStorage.setItem('name', JSON.stringify(res.data.result.fullName))
      } else {
        localStorage.setItem('name', 'customer name')
      }
      let localTheme =
        res.data.result.theme.code === 'Youth' ? youthTheme : defaultTheme

      res.data.result.theme.lightMode = {
        ...localTheme.lightMode,
        ...res.data.result.theme.lightMode,
      }
      res.data.result.theme.darkMode = {
        ...localTheme.darkMode,
        ...res.data.result.theme.darkMode,
      }

      if (!JSON.parse(localStorage.getItem('isPaltelCustomer'))) {
        if (res.data.result.isCorpAutherized) {
          localStorage.setItem('clickedLogin', 'Jawwal')
        } else if (res.data.result.corpAuthorized) {
          localStorage.setItem('clickedLogin', 'Paltel')
        }
      }

      if (
        !localStorage.getItem('themeName') ||
        localStorage.getItem('themeName') !== res.data.result.theme.code
      ) {
        localStorage.setItem(
          'light',
          JSON.stringify(res.data.result.theme.lightMode)
        )
        localStorage.setItem(
          'dark',
          JSON.stringify(res.data.result.theme.darkMode)
        )
        updateCssVariables(res.data.result.theme.lightMode)
        localStorage.setItem('themeName', res.data.result.theme.code)
      }
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General Error'
  }
  return responseData
}

export const getCustomerPackageInfoApi = async () => {
  let responseData = { data: {}, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.GetCurrentPackageDetails}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
    } else {
      responseData.error = res.data
    }
  } catch {
    responseData.error = 'General Error'
  }
  return responseData
}
export const getAvailableProgramsAPi = async () => {
  let responseData = { data: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.package.root}${ENDPOINTS.package.available}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'There is no eligible packages'
  }
  return responseData
}

export const getPackageDetailsAPi = async (option) => {
  let responseData = { data: {}, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.package.root}${ENDPOINTS.package.packageDetails}${option}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
    } else {
      responseData.error = res.data
    }
  } catch {
    responseData.error = 'There is an Error accrued while get package details'
  }
  return responseData
}

export const getBillsInfoAPi = async () => {
  let responseData = {
    unpaidBills: [],
    paidBills: [],
    chartBills: {
      maxBill: 0,
      data: {},
    },
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.lastInvoices}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      let invoiceData = {},
        chartData = {}
      res.data.result.forEach(function (invoiceInfo, index) {
        const dueData = new Date(invoiceInfo.dueDate)
        const cycleDate = new Date(invoiceInfo.cycleDate)
        const paidData = new Date(invoiceInfo.paidDate)

        invoiceData = {
          ePayemntAmount: invoiceInfo.ePayemntAmount,
          totalPaidAmount: invoiceInfo.totalPaidAmount,
          remainingAmount: invoiceInfo.remainingAmount,
          cycleDate: {
            year: cycleDate.getFullYear(),
            month: cycleDate.getMonth() + 1,
            day: cycleDate.getDate(),
          },
          cycleDataAsFullData: invoiceInfo.cycleDate,
          dueDate: {
            year: dueData.getFullYear(),
            month: dueData.getMonth() + 1,
            day: dueData.getDate(),
          },
          paidDate: {
            year: paidData.getFullYear(),
            month: paidData.getMonth() + 1,
            day: paidData.getDate(),
          },
          amount: invoiceInfo.amount,
          downloadUrl: invoiceInfo.downloadUrl,
          isLastBill: index ? false : true,
          checked: false,
          invoiceNumber: invoiceInfo.invoiceNumber,
          pdfParam: invoiceInfo.pdfParam,
          cycleNumber: invoiceInfo.cycleNumber,
        }
        if (index < 6) {
          responseData.chartBills.maxBill =
            invoiceInfo.amount > responseData.chartBills.maxBill
              ? invoiceInfo.amount
              : responseData.chartBills.maxBill
          chartData[invoiceInfo.invoiceID] = {
            amount: invoiceInfo.amount,
            month: parseInt(invoiceInfo.cycleNumber, 10),
            year: cycleDate.getFullYear(),
            paid: invoiceInfo.status,
          }
          responseData.chartBills.data = Object.assign(
            chartData,
            responseData.chartBills.data
          )
        }
        if (invoiceInfo.status === CONSTANTS.PAID_BILL) {
          responseData.paidBills.push(invoiceData)
        } else {
          responseData.unpaidBills.push(invoiceData)
        }
        invoiceData = {}
      })
    } else {
      responseData.error = res.data
    }
  } catch (e) {
    responseData.error = 'There is an Error accrued while get Bills details'
  }
  return responseData
}
export const getInstallmentsAPI = async () => {
  let responseData = {
    data: {},
    hasInstallments: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.installment}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
      responseData.hasInstallments = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while getting devices'
  }
  return responseData
}

export const getTermsAndConditionsAPi = async (option) => {
  let responseData
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.package.root}${ENDPOINTS.package.termsAndConditions}${option}`
    )
    if (res?.data?.responseCode === CONSTANTS.SUCCESS) {
      responseData = res?.data?.result?.value
    } else {
      responseData = 'An Error accrued while getting terms and conditions'
    }
  } catch {
    responseData = 'An Error accrued while getting terms and conditions'
  }
  return responseData
}
export const postExchangeProgram = async (currentCode, chosenCode) => {
  let responseData = { data: {}, success: false, pending: false, error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.package.root}${ENDPOINTS.package.executeCommand}`,
      {
        newPackageCode: chosenCode,
        packageCode: currentCode,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
      responseData.success = true
    } else if (res.data.responseCode === -1) {
      responseData.pending = true
      responseData.success = false
      responseData.error = res.data
    } else {
      responseData.error = res.data
    }
  } catch {
    responseData.error = 'General error while changing programs'
  }
  return responseData
}

export const getServiceInfoFromAPI = async () => {
  let responseData = {
    data: [],
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getActiveService}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting Services'
  }
  return responseData
}
export const getTransactionType = async () => {
  let responseData = { data: {}, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.myTransactions.root}${ENDPOINTS.myTransactions.transactionsTypes}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.result
    }
  } catch {
    responseData.error = 'General error while fetching Transactions Types '
  }
  return responseData
}
export const getTransactionInfo = async (type, fromDate, toDate) => {
  let responseData = { data: [], noData: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.myTransactions.root}${ENDPOINTS.myTransactions.transactions}`,
      {
        params: { TransactionType: type, startDate: fromDate, endDate: toDate },
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    }
    if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
      responseData.noData = true
      responseData.error = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'General error while fetching Transactions'
  }
  return responseData
}

export const getBillsDetails = async (option) => {
  let responseData = {
    data: [],
    categories: [],
    bills:[],
    vatAmount: 0,
    error: null,
    total:0
    
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.getInvoiceDetails}${option}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {

      if(JSON.parse(localStorage.getItem('customerType')) !== 3){
        const categorizedBills = res.data.result.map((entry) => {
          const { msisdn, categories, bills, vat, billId,total } = entry
          const billsByCategory = categories.map((category) => {
            const billsForCategory = bills.filter(
              (bill) => bill.categoryId === category.categoryId
            )
            return {
              categoryName: category.categoryName,
              categoryAmount: category.categoryAmount,
              categoryIcon: category.icon,
              bills: billsForCategory,
            }
          })
  
          return {
            billId,
            msisdn,
            categories: billsByCategory,
            vatAmount: parseFloat(vat) || 0, 
            total:total
          }
        })
        const totalVatAmount = categorizedBills.reduce((acc, entry) => {
          return  entry.vatAmount
        }, 0)
  
        responseData.data = categorizedBills
        responseData.vatAmount = totalVatAmount.toFixed(2) 
      }else{
        responseData.bills = res.data.result.bills
        responseData.vatAmount = res.data.result.vat
      }
    } 
    else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting bills Info'
  }
  return responseData
}

export const getCallsDetails = async (infoId, billNo) => {
  let responseData = {
    data: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.getCallsDetails}?infoId=${infoId}&billNo=${billNo}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting calls details'
  }
  return responseData
}

export const getSwitchOption = async (option) => {
  let responseData = {
    data: [],
    message: '',
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getSwitchOption}${option}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
      responseData.message = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting switchOption'
  }
  return responseData
}

export const setSwitchOption = async (option) => {
  let responseData = {
    isSet: false,
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.setSwitchOption}${option}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSet = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while changing switch option'
  }
  return responseData
}

export const getSwitchAllowedOption = async () => {
  let responseData = {
    data: [],
    chosen: '',
    error: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getSwitchAllowedOption}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
      res.data.result.forEach((element) =>
        element.selected ? (responseData.chosen = element.name) : ''
      )
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting switchOption'
  }
  return responseData
}
export const getDeviceDetails = async (deviceId) => {
  let responseData = {
    data: {},
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getDeviceDetails}`,
      {
        params: { deviceId: deviceId },
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting device details'
  }
  return responseData
}
export const updateFixedLineCallDetailsFlag = async (data) => {
  let responseData = {
    msg: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.updateFixedLineCallDetailsFlag}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while getting my Numbers'
  }
  return responseData
}

export const getMyNumbersFromApi = async (data) => {
  let responseData = {
    myNumbers: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getMyNumbers}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.myNumbers = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while getting my Numbers'
  }
  return responseData
}
export const switchWithOTP = async (number, pin, savePin) => {
  let responseData = {
    data: [],
    error: '',
    success: false,
    mobileNo: '',
  }
  const data =
    pin === undefined
      ? {
          SerialNumber: number,
          OSType: CONSTANTS.OS_TYPE,
          appVersion: CONSTANTS.APP_VERSION,
        }
      : {
          SerialNumber: number,
          OSType: CONSTANTS.OS_TYPE,
          pin: pin,
          appVersion: CONSTANTS.APP_VERSION,
          savePin: savePin,
        }

  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.switchToMyNumbers}`,
      data
    )
    if (
      res.data.responseCode === CONSTANTS.SUCCESS ||
      res.data.responseCode === CONSTANTS.EMPTY_STATE
    ) {
      responseData.data = res.data
      responseData.mobileNo = res.data.result.mobileNo
      responseData.success = true
    } else {
      responseData.data = res.data
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = `Error occurred while switch to ${'0' + number}`
  }
  return responseData
}

export const switchMyNumbersWithoutPin = async (number) => {
  let responseData = {
    data: [],
    error: '',
  }

  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.switchMyNumbersWithoutPin}`,
      {
        SerialNumber: number,
        appVersion: CONSTANTS.APP_VERSION,
        osType: CONSTANTS.OS_TYPE,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = `Error occurred while switch to ${number}`
  }
  return responseData
}
export const uploadPicFromAPI = async (data) => {
  let responseData = {
    isUpload: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.uploadPic}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isUpload = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while uploading profile pic'
  }
  return responseData
}

export const downloadPicFromAPI = async () => {
  let responseData = {
    imgURL: {},
    hasImage: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.downloadPic}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.imgURL = res.data.result
      responseData.hasImage = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while downloading profile pic'
  }
  return responseData
}
export const getNotificationFromAPI = async () => {
  let responseData = {
    hasNotification: false,
    count: 0,
    notificationList: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getNotification}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.hasNotification = true
      responseData.count = res.data.result.unReadCount
      responseData.notificationList = res.data.result.notifications
    } else {
      responseData.hasNotification = false
      responseData.message = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while getting notifications List'
  }
  return responseData
}
export const makeNotificationAsRead = async (notificationIds) => {
  let responseData = {
    isSuccess: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.markNotificationAsRead}`,
      {
        notificationIds: notificationIds,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
    }
  } catch (error) {
    responseData.error = 'General error while make notifications as read'
  }
  return responseData
}
export const setSMSAdvertisementStatus = async (smsStatus) => {
  let responseData = {
    isSuccess: false,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.setSMSAdvertisementStatus}?smsStatus=${smsStatus}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
    }
    responseData.msg = res.data.responseMessage
  } catch (error) {
    responseData.msg = 'General error while setting sms advertisement status'
  }
  return responseData
}
export const getSMSAdvertisementStatus = async () => {
  let responseData = {
    status: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getSMSAdvertisementStatus}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.status = res.data.result
    }
  } catch (error) {
    responseData.error = 'General error while getting sms advertisement status'
  }
  return responseData
}
export const setNotificationAdvertisementStatus = async (
  notificationStatus
) => {
  let responseData = {
    isSuccess: false,
    msg: '',
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.setNotificationAdvertisementStatus}?notificationStatus=${notificationStatus}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
    }
    responseData.msg = res.data.responseMessage
  } catch (error) {
    responseData.msg =
      'General error while setting notification advertisement status'
  }
  return responseData
}

export const getNotificationAdvertisementStatus = async () => {
  let responseData = {
    status: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getNotificationAdvertisementStatus}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.status = res.data.result
    }
  } catch (error) {
    responseData.error =
      'General error while getting notification advertisement status'
  }
  return responseData
}
export const sendFCMTokenToBE = async (fcmToken) => {
  let responseData = {
    isSuccess: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.sendFCMToken}`,
      {
        fcmToken: fcmToken,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
    }
  } catch (error) {
    responseData.error = 'General error while sending FCM token'
  }
  return responseData
}

export const getInvoicePDF = async (pdfParam) => {
  let responseData = {
    pdfUrl: '',
    isSuccess: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.getInvoicePDF}`,
      {
        pdfParam: pdfParam,
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.pdfUrl = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while downloading the PDF'
  }
  return responseData
}

export const getListOfBioDevices = async () => {
  let responseData = {
    data: {},
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getListOfBioDevices}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'Error accrued while getting List of Bio devices'
  }
  return responseData
}
export const InvalidateBiometric = async (data) => {
  let responseData = {
    isSuccess: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.invalidateBiometric}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
    }
  } catch (error) {
    responseData.error = 'General error while Invalidating Biometric'
  }
  return responseData
}

export const updateQuickAccess = async (data) => {
  let responseData = {
    error: null,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.updateQuickAccess}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while updating the quick access'
  }
  return responseData
}
export const getQuickAccessPagesListApi = async () => {
  let responseData = {
    QuickAccessPagesList: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getQuickAccessPagesList}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.QuickAccessPagesList = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while getting Quick acces page list'
  }
  return responseData
}
export const updateProfileSendPin = async () => {
  let responseData = {
    error: null,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.updateProfileSendPin}?osType=android`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.responseMessage
    } else {
      responseData.error = res.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while updating profile'
  }
  return responseData
}
export const updateProfile = async (data) => {
  let responseData = {
    error: null,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.updateProfile}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while updating profile'
  }
  return responseData
}

export const getProfileDataFromApi = async () => {
  let responseData = {
    data: [],
    error: null,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.profileData}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while getting profile data'
  }
  return responseData
}
export const submitReflectInformation = async (data) => {
  let responseData = {
    isSuccess: false,
    error: null,
    responseTitle: null,
    responseMessage: null,
  }
  try {
    const deviceId = localStorage.getItem('deviceId')
    const res = await authenticatedAxios.post(
      'winners/SubmitReflectInformation',
      data,
      {
        headers: {
          DeviceId: deviceId || '',
        },
      }
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS || res.data.responseCode === 0) {
      responseData.isSuccess = true
      const message = res.data.responseMessage || 'Success'
      responseData.responseMessage = message
      responseData.responseTitle =
        res.data.responseTitle ??
        res.data.ResponseTitle ??
        message ??
        'Success'
    } else {
      responseData.error = res.data.responseMessage || 'Failed to submit reflect information'
    }
  } catch (error) {
    responseData.error = error.response?.data?.responseMessage || error.message || 'General error while submitting reflect information'
  }
  return responseData
}

/**
 * @param {string} msisdn
 * @param {string} pin - 4-digit OTP
 * @param {Object} [reflectData] - optional payload to resend with VerifyPin
 * @param {string} [reflectData.reflectMobileNumber]
 * @param {string} [reflectData.firstNameEnglish]
 * @param {string} [reflectData.secondNameEnglish]
 * @param {string} [reflectData.reflectIbanNis]
 * @param {string} [reflectData.reflectIbanJod]
 * @param {string} [reflectData.reflectIbanUsd]
 */
export const verifyReflectPin = async (msisdn, pin, reflectData = {}) => {
  let responseData = {
    isSuccess: false,
    error: null,
  }
  try {
    const body = {
      msisdn: String(msisdn || '').trim(),
      pin: String(pin || '').trim(),
      reflectMobileNumber: String(reflectData.reflectMobileNumber ?? '').trim(),
      firstNameEnglish: String(reflectData.firstNameEnglish ?? '').trim(),
      secondNameEnglish: String(reflectData.secondNameEnglish ?? '').trim(),
      reflectIbanNis: String(reflectData.reflectIbanNis ?? '').trim(),
      reflectIbanJod: String(reflectData.reflectIbanJod ?? '').trim(),
      reflectIbanUsd: String(reflectData.reflectIbanUsd ?? '').trim(),
    }
    const res = await authenticatedAxios.post('winners/VerifyPin', body)
    if (res.data.responseCode === CONSTANTS.SUCCESS || res.data.responseCode === 0) {
      responseData.isSuccess = true
    } else {
      responseData.error = res.data.responseMessage || 'Invalid PIN'
    }
  } catch (error) {
    responseData.error = error.response?.data?.responseMessage || error.message || 'Verification failed'
  }
  return responseData
}

export const getEsimPDF = async (simNo) => {
  let responseData = {
    pdfUrl: '',
    isSuccess: false,
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getEsimPDF}?simNo=${simNo}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.pdfUrl = res.data.result.pdfFile
    }
  } catch (error) {
    responseData.error = 'General error while downloading the Esim QR PDF'
  }
  return responseData
}

export const getInFlightInternetBrowsing = async () => {
  let responseData = {
    data: [],
    error: '',
  }
  if (isFixedLineCustomer()) {
    responseData.error = null
    return responseData
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.roaming.root}${ENDPOINTS.roaming.getInFlightInternetBrowsing}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'Error accrued while getting inflight internet browsing'
  }
  return responseData
}

export const subscribeInFlightInternetBrowsing = async (data) => {
  let responseData = {
    error: null,
    isSuccess: false,
    msg: null,
  }
  if (isFixedLineCustomer()) {
    responseData.error = 'Service not available for fixed line customers'
    return responseData
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.roaming.root}${ENDPOINTS.roaming.subscribeInFlightInternetBrowsing}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isSuccess = true
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'General error while subscribe to  inflight internet browsing'
  }
  return responseData
}

export const getActiveInstallmentWithWarranty = async (installmentNo) => {
  let responseData = {
    data: {},
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.getActiveInstallmentWithWarranty}?installmentNo=${installmentNo}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error =
      'Error accrued while getting active installment with warranty '
  }
  return responseData
}
export const getAvaliableShowroomsforWarranty = async () => {
  let responseData = {
    cites: [],
    allShowRoomsWithCityData: [],
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.getAvaliableShowroomsforWarranty}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.allShowRoomsWithCityData = res.data.result
      res.data.result.forEach(function (showRoomsInfo) {
        responseData.cites.push(showRoomsInfo.city)
      })
    }
    responseData.msg = res.data.responseMessage
  } catch (e) {
    responseData.msg =
      'Error accrued while getting avaliable showrooms for warranty'
  }
  return responseData
}
export const updateShowroomforWarranty = async (data) => {
  let responseData = {
    error: null,
    msg: null,
  }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.invoice.root}${ENDPOINTS.invoice.updateShowroomforWarranty}`,
      data
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.msg = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (error) {
    responseData.error = 'General error while updating showroom for warranty '
  }
  return responseData
}
